import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaDirections, FaPhone, FaQuestionCircle } from 'react-icons/fa';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from '../../../Components/Header';
import Footer from '../../../Components/Footer';
import { ApiService } from '../../../Components/Services/apiServices';

const BookingConfirmation = () => {
    const { bookingId } = useParams();
    const [bookingdetails, setBookingDetails] = useState("");
    const [userDetails, setUserDetails] = useState(null);

    const navigate = useNavigate();


    const getFormattedDate = (dateString) => {
        const date = new Date(dateString);
        const options = { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };

    useEffect(() => {
        const fetchBookingDetail = async () => {
            try {
                const bookingDetailData = await ApiService.Commanfetchrequest(`booking/${bookingId}`);
                setBookingDetails(bookingDetailData.booking);
                setUserDetails(bookingDetailData.user);
                console.log('room detail:', bookingDetailData.booking);
                // console.log('User details:', bookingDetailData.user);

            } catch (error) {
                console.log('Error while fetching:', error);
            }
        };

        fetchBookingDetail();
    }, [bookingId]);

    if (!bookingdetails) {
        return <div>Loading...</div>;
    }


    const handleCancelBooking = async () => {
        if (window.confirm("Are you sure you want to cancel this booking?")) {
            try {
                const response = await ApiService.Commanpostrequest(`cancel-booking/${bookingId}`, { bookingId });

                if (response.message) {
                    // alert("Booking canceled successfully");
                    navigate(`/cancel-booking/${bookingId}`); 
                } else {
                    alert("Failed to cancel booking. Please try again.");
                }
            } catch (error) {
                console.log("Error while canceling booking:", error);
                alert("An error occurred. Please try again.");
            }
        }
    };

    return (
        <>
            <Header />
            <div className="container py-5">
                <h2 className="text-center text-primary mb-4">Your Booking is Confirmed</h2>

                <div className="text-center mb-5">
                    <p style={{ fontSize: "16px", fontWeight: "600" }}>Pay now & save time during check-in</p>
                    <p>Pending amount:    <span style={{ fontWeight: "600" }}>₹{bookingdetails.total_price}</span></p>
                    <button className='btn btn-primary w-50'>Pay ₹{bookingdetails.total_price} now</button>
                </div>

                {/* Room Name and Address */}
                <div className="row mb-5">
                    <div className="col-12 col-md-6">
                        <h4 style={{ fontWeight: "700" }}>WeJai</h4>
                        <p>{bookingdetails.room_name}</p>
                        <p>Pratap Nagar, Sect-9, Jaipur-302033</p>
                    </div>
                </div>

                {/* Icons Section */}
                <div className="row text-center mb-5">
                    <div className="col-4">
                        <FaDirections size={30} />
                        <p>Directions</p>
                    </div>
                    <div className="col-4">
                        <FaPhone size={30} />
                        <p>Call Hotel</p>
                    </div>
                    <div className="col-4">
                        <FaQuestionCircle size={30} />
                        <p>Need Help</p>
                    </div>
                </div>

                {/* Dates */}
                <div className="row mb-5">
                    <div className="col-6">
                        <p style={{ fontWeight: "700" }}>Check-in Date:</p>
                        <p>{getFormattedDate(bookingdetails.check_in)}</p>
                        <p style={{ fontSize: "12px" }}>12:00 PM onward</p>
                    </div>
                    <div className="col-6">
                        <p style={{ fontWeight: "700" }}>Check-out Date:</p>
                        <p>{getFormattedDate(bookingdetails.check_out)}</p>
                        <p style={{ fontSize: "12px" }}>Before 11:00 AM</p>
                    </div>
                </div>


                {/* Booking ID */}
                <div className="mb-5">
                    <p style={{ fontWeight: "700" }}>Booking ID: <span style={{ fontWeight: "400" }}>{bookingdetails?.booking_id}</span></p>
                </div>

                {/* Reserved for */}
                <div className="row mb-5">
                    <div className="col-12 col-md-6">
                        <p style={{ fontWeight: "700" }}>Reserved For:  <span style={{ fontWeight: "400" }}>{userDetails.full_name}</span></p>
                        <p style={{ fontWeight: "700" }}>Room: <span style={{ fontWeight: "400" }}>{bookingdetails.rooms} Room(s)</span></p>
                        <p style={{ fontWeight: "700" }}>Guests: <span style={{ fontWeight: "400" }}>{bookingdetails.guests} Guest(s)</span></p>
                    </div>
                    <div className="col-12 col-md-6">
                        <p style={{ fontWeight: "700" }}>Contact Information:</p>
                        <p>{userDetails.email}</p>
                        <p>{userDetails.mobile}</p>
                    </div>
                </div>

                {/* Important Notes */}
                <div className="row mb-2">
                    <div className="col-12">
                        <h6 style={{ fontWeight: "700" }}>Important to Note:</h6>
                        <div className="row mb-5">
                            <div className="col-6">
                                <p>Check-in:</p>
                                <p style={{ fontSize: "12px" }}>12:00 PM</p>
                            </div>
                            <div className="col-6">
                                <p>Check-out</p>
                                <p style={{ fontSize: "12px" }}>Till 11:00 AM</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mb-5">
                    <div className="col-12">
                        <h6 style={{ fontWeight: "700" }}>Rules & Restrictions:</h6>
                        <ul style={{ paddingLeft: "20px" }}>
                            <li>Couples are welcome</li>
                            <li>Guests can check in using any local or outstanding ID proof (PAN card not accepted).</li>
                            <li>Check-in time: 12:00 PM onward</li>
                            <li>Check-out time: Before 11:00 AM</li>
                        </ul>
                        <Link to="#">View guest policy</Link>
                    </div>
                </div>


                {/* Cancel Booking Button */}
                <div className="text-center">
                    <Button variant="danger" size="lg" onClick={handleCancelBooking}>Cancel Booking</Button>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BookingConfirmation;
